import {
  PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_BEGIN,
  PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_SUCCESS,
  PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_FAILURE,
  PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function installLoginPlugin(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/project-on-board/install-login-plugin`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_SUCCESS,
              data: res,
            });
            toast.success('Installed Successfully !', {});
            Mixpanel.track('Installed Login plugin on Project Onboarding');
            resolve(res);
          } else {
            dispatch({
              type: PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Installation Failed: ${errMsg}`, {});
            Mixpanel.track('Failed to install Login plugin on Project Onboarding');
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to install Login plugin on Project Onboarding');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissInstallLoginPluginError() {
  return {
    type: PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_BEGIN:
      return {
        ...state,
        installLoginPluginPending: true,
        installLoginPluginError: null,
      };

    case PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_SUCCESS:
      return {
        ...state,
        installLoginPluginPending: false,
        installLoginPluginError: null,
      };

    case PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_FAILURE:
      return {
        ...state,
        installLoginPluginPending: false,
        installLoginPluginError: action.data.error,
      };

    case PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_DISMISS_ERROR:
      return {
        ...state,
        installLoginPluginError: null,
      };

    default:
      return state;
  }
}
